import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { InvoiceSystemSettingsContainer } from "@/components/features/invoice-system-settings";

import { useConfirmParams } from "./hooks";

export const InvoiceSystemSettingsPage = () => {
	const result = useConfirmParams();

	const { canRender } = result;
	if (!canRender) return <></>;

	const { hotelID } = result;

	return (
		<PageMeta title="インボイスに関する設定" url={generatePath(PATHS.HOTEL.INVOICE_SYSTEM.SETTINGS, { hotelID })}>
			<InvoiceSystemSettingsContainer hotelID={hotelID} />
		</PageMeta>
	);
};
